import React, { useEffect, useState } from 'react'
import AuthCardContainer from '../Register/AuthCardContent';
import { Box, Typography } from '@mui/material';
import { CustomButton, TextField } from '../../../v2/MUI_custom_component';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { MOBILE_REGEX } from '../Register/Components/regex';
import IconReusable from '../../../components/IconReusable';
import { encryptPassword } from '../../../v2/Utils/Encryption/NodeForgeEncryption';
import { OTP_PURPOSE_ENUM } from '../Enum';
import { sendOTPAction } from '../Register/API/Action';

const ForgetPin = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [mobile, setMobile] = useState('');
    const [mobileErr, setMobileErr] = useState('');
    const [loading, setLoading] = useState(false);
    const [apiError, setApiError] = useState('');
    const handleSendOtp = async () => {
        if (!MOBILE_REGEX.test(mobile)) {
          setMobileErr('Enter valid 10-digit mobile number');
          return;
        }
        setMobileErr('');
        setLoading(true);
        const encryptedMobile = encryptPassword(mobile);
        const payload = { 
            mobile_number: encryptedMobile,
            purpose: OTP_PURPOSE_ENUM.RESET
        };
        const {data, error, message} = await sendOTPAction(payload);
        setLoading(false);
        if (!error) {
            dispatch({ type: 'SET_MOBILE', payload: encryptedMobile });
            navigate('/otp', {state: { mobile_no: mobile }});
        } else {
            setApiError(message);
        }
    };
    useEffect(() => {
        dispatch({ type: 'LOGOUT' });
        dispatch({ type: 'RESET_AUTH'});
        dispatch({ type: 'RESET_FIRM_ONBOARDING_REDUCER'});
        dispatch({ type: 'SET_OTP_PURPOSE', payload: OTP_PURPOSE_ENUM.RESET });
    }, []);
    const isOTPFormValid = MOBILE_REGEX.test(mobile);

    return (
        <AuthCardContainer>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Typography variant='h1' sx={{ color: '#666666' }}>Forgot ePin?</Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <TextField
                            label="Mobile Number*"
                            value={mobile}
                            onChange={e => setMobile(e.target.value.replace(/\D/g, '').slice(0, 10))}
                            placeholder="Enter Mobile number"
                            error={!!mobileErr}
                            helperText={mobileErr}
                        />
                        {mobileErr && <Typography variant="body2" sx={{ color: '#CC0000', minHeight: 20 }}>{mobileErr}</Typography> } 
                        {apiError && (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <IconReusable name="ErrorFilled" size={20} color="#CC0000" />
                            <Typography variant='body1' sx={{ color: '#CC0000', }}>
                                {apiError}
                            </Typography>
                            </Box>
                        )}
                    </Box>
                </Box>
                <CustomButton
                    variant="filled"
                    disabled={loading || !isOTPFormValid}
                    label={'Send OTP'}
                    fullWidth
                    onClick={handleSendOtp}
                />
            </Box>
        </AuthCardContainer>
    );
}

export default ForgetPin